export const getGreeting = () => {
  const hour = new Date().getHours();
  const welcomeTypes = ["Good Morning", "Good Afternoon", "Good Evening"];

  if (hour < 12) return welcomeTypes[0];
  else if (hour < 18) return welcomeTypes[1];
  else return welcomeTypes[2];
};
